import dayjs from 'dayjs'

import { CreateCompetition } from '@/middlewares/services/competition.services'

/** Fields in form order: the first one in error receives focus on submit. */
export const CREATE_EVENT_FIELDS = ['name', 'location', 'category', 'country', 'dates']

/** Every error at once (mock create.html submit()): { field: message }. */
export const validateCreateEvent = ({ name, type, location, category, country, start, end }, t) => {
    const errors = {}
    if (!name || !name.trim()) errors.name = t('Give the event a name.')
    // The backend requires a geocoded location for a physical event (utils/Competition validator).
    if (type === 'inside' && !(location?.location || '').trim()) errors.location = t("Choose the event's location.")
    if (!category) errors.category = t('Choose a category.')
    if (!country || !country.trim()) errors.country = t("Choose the event's country.")
    if (!start) errors.dates = t('Choose the first and last day.')
    else if (!end) errors.dates = t('Choose the last day.')
    return errors
}

/** 08:00 on the first day → 20:00 on the last day, in the event's own time zone, as UTC ISO. */
export const buildEventDates = (start, end, timezone) => ({
    start: dayjs.tz(`${start}T08:00:00`, timezone).utc().format(),
    end: dayjs.tz(`${end}T20:00:00`, timezone).utc().format(),
})

/** Creates the competition and resolves with its eventNumber (the organizer dashboard route). */
export const submitCreateEvent = async (values, orgaId) => {
    const { start, end } = buildEventDates(values.start, values.end, values.timezone)
    const physical = values.type === 'inside'
    const response = await CreateCompetition(
        values.name.trim(),
        values.type,
        values.category,
        physical ? values.location.location : undefined,
        physical ? values.location.longitude : undefined,
        physical ? values.location.latitude : undefined,
        values.country,
        values.timezone,
        start,
        end,
        orgaId,
    )
    return response.data?.data?.eventNumber
}

/**
 * The backend answers 400 both for missing fields (with a message, "Some required fields are
 * missed") and for a name already taken (a bare `{ status: 400 }`).
 */
export const isDuplicateNameError = (error) => error?.response?.status === 400 && !error.response.data?.message
